// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xUu5","image":"Header_image__2oUfb","name":"Header_name__3Kq6f","info":"Header_info__37ant","infoRow":"Header_infoRow__2NiIG"};